export default __webpack_public_path__ + "static/media/apple.7d60919d.svg";